export default {"src":"/_next/static/media/info_basic_icon.d00658ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};